import { takeEvery, put, call } from 'redux-saga/effects';
import { AuthActions } from '../../actions/constant';
import authService from '../../../services/apiServices/authService';
import { SagaReturnType } from 'redux-saga/effects';
import cookieService from 'src/services/tokenManagementService/cookiesStorageService';
import {
  therapistToken,
  therapistRefreshToken,
  therapistIdToken,
} from 'src/services/tokenManagementService/constant';
import { generateUrlForKeyclockLogin } from 'src/utils/generate-url';

const { THERAPIST_LOGOUT_REQUEST, THERAPIST_LOGOUT_SUCCESS, THERAPIST_LOGOUT_FAILURE } =
  AuthActions;

function* getTherapistLogout(action: any): SagaReturnType<any> {
  try {
    const response = yield call(authService.logout, action.payload, action.subdomain);
    if (response?.status === 204) {
      cookieService.removeValue(therapistToken);
      localStorage.removeItem('isCheckIn');
      localStorage.removeItem('lastRunningTime');
      cookieService.removeValue(therapistRefreshToken);
      cookieService.removeValue(therapistIdToken);
      localStorage.removeItem('facility_timezone');
      localStorage.removeItem('persist:root');
      localStorage.clear();
      yield put({ type: THERAPIST_LOGOUT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    cookieService.removeValue(therapistToken);
    localStorage.removeItem('isCheckIn');
    localStorage.removeItem('lastRunningTime');
    cookieService.removeValue(therapistRefreshToken);
    cookieService.removeValue(therapistIdToken);
    localStorage.removeItem('facility_timezone');
    localStorage.removeItem('persist:root');
    localStorage.clear();
    // window.location.assign(generateUrlForKeyclockLogin(true));
    yield put({ type: THERAPIST_LOGOUT_FAILURE, payload: error });
  }
}

function* therapistLogoutSaga() {
  yield takeEvery(THERAPIST_LOGOUT_REQUEST, getTherapistLogout);
}

export default therapistLogoutSaga;
